// 클립보드 복사 유틸 — HTTP(비-secure context) 환경 폴백 포함.
//
// 배경(고객 피드백): navigator.clipboard 는 secure context(HTTPS/localhost)에서만
// 존재한다. 고객사처럼 내부망 HTTP 로 접속하면 undefined 라
// `navigator.clipboard.writeText` 가 TypeError 로 죽고 복사가 안 됐다.
//
// 동작: clipboard API 가능하면 사용, 아니면 임시 textarea + execCommand('copy')
// 레거시 폴백(HTTP 에서도 동작). 실패 시 reject — 호출부가 토스트로 안내.

export async function copyToClipboard(text) {
  const value = text ?? ''
  // 1) 표준 API — secure context 에서만 존재
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(value)
      return
    } catch {
      // 권한 거부 등 — 아래 레거시 폴백 시도
    }
  }
  // 2) 레거시 폴백 — 임시 textarea 선택 후 execCommand('copy')
  const ta = document.createElement('textarea')
  ta.value = value
  // 화면 밖 + 스크롤 점프 방지
  ta.style.position = 'fixed'
  ta.style.top = '0'
  ta.style.left = '-9999px'
  ta.setAttribute('readonly', '')
  document.body.appendChild(ta)
  try {
    ta.select()
    ta.setSelectionRange(0, ta.value.length)
    const ok = document.execCommand('copy')
    if (!ok) throw new Error('execCommand copy 실패')
  } finally {
    document.body.removeChild(ta)
  }
}
